import { notification } from 'antd';
import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { useFBOauthTokensCRUDActions } from '@mm/state/actions/FBOauthTokensCRUDActions';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';

import { PrimaryButton } from 'src/common/buttons/PrimaryButton/PrimaryButton';
import { useInitFacebookSDK } from '@mm/state/hooks/use-init-facebook-sdk';

type Props = {
  className?: string;
  text?: string;
  refreshIcon?: boolean;
};

const FB_VERSION = 'v20.0';
const DEFAULT_TEXT = 'Connect Facebook Page';

export const FacebookAdsConnect: FunctionComponent<Props> = ({
  className,
  text = DEFAULT_TEXT,
  refreshIcon = false,
}) => {
  const facebookPageId = useSelector(activeFacebookPageIdSelector);
  const fbOauthTokensCRUDActions = useFBOauthTokensCRUDActions();
  useInitFacebookSDK(FB_VERSION);

  const scope =
    'email,ads_read,ads_management,pages_manage_ads,business_management';

  const options: facebook.LoginOptions = {
    auth_type: 'rerequest' as facebook.LoginOptions['auth_type'],
    return_scopes: true,
    enable_profile_selector: true,
    scope,
  };

  const handleFBLogin = (response: fb.StatusResponse) => {
    if (response.status === 'connected') {
      saveLLToken(response.authResponse.accessToken);
    } else {
      notification.error({
        message: 'Failed to connect the Facebook account',
      });
    }
  };

  const onLoginClick = async () => {
    FB.login(handleFBLogin, options);
  };

  const saveLLToken = async (token: string) => {
    if (!facebookPageId) {
      throw new Error('No active Facebook page');
    }
    if (!token) {
      throw new Error('No access token');
    }

    try {
      await fbOauthTokensCRUDActions.create({
        facebookPageId,
        token,
      });
    } catch (err) {
      notification.success({
        message: 'The Facebook account has been connected successfully',
      });
      return;
    }

    fbOauthTokensCRUDActions.retrieveAll({
      facebookPageId,
    });
  };

  return (
    <PrimaryButton
      onClick={onLoginClick}
      className={className}
      leftIcon={refreshIcon && <i className="fas fa-redo-alt" />}
    >
      {text}
    </PrimaryButton>
  );
};
